<template>
  <div class="mc-dropdown" ref="dropdown">
    <slot/>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    name: 'mcBaseDropdown',
    data(){
      return{

      }
    },
    mounted(){
      // 下拉DOM插入到文档底部
      document.body.appendChild(this.$el);
    },
    beforeDestroy(){
      document.body.removeChild(this.$el);
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/base-dropdown.vue